import { createContext, useContext } from "react";

export interface StaffMe {
  userId: string;
  sessionId: string;
  role: "developer" | "admin" | "moderator" | "support";
  permissions?: string[];
  displayName: string | null;
  username: string | null;
  avatarUrl: string | null;
}

export const StaffMeContext = createContext<StaffMe | null>(null);

export function useStaffMe(): StaffMe {
  const ctx = useContext(StaffMeContext);
  console.log("useStaffMe called, context value is:", ctx);
  if (!ctx) {
    console.error("useStaffMe used outside StaffMeContext! Returning dummy data for debugging.");
    return {
      userId: "dummy",
      sessionId: "dummy",
      role: "developer",
      displayName: "Dummy",
      username: "dummy",
      avatarUrl: null
    };
  }
  return ctx;
}
